import EfIcon from '@elem/ui/ef-icon';
import EfLink from '@elem/ui/ef-link';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');

    return (
        <div id="amazon-sale-G" className={`amazon-sale-G ${css['amazon-sale-G']}`}>
            <div className="section-content">
                <p className="title">{t('sectionG_title')}</p>
                <div className="line-content">
                    <div className="line-img">
                        <EfLink href="https://lin.ee/9LESuPK">
                            <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1724058645017/amazon_sale_g_line.png" />
                        </EfLink>
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1724058668680/amazon_sale_g_qrc.png" />
                    </div>
                    <p className="text">{t('sectionG_title')}</p>
                </div>
            </div>
        </div>
    );
}
